module.exports = __webpack_public_path__ + "media/images/badge-check-active-1db3deecf4b2e5afd41384535b6d0a17.svg";